import { Component, OnInit } from '@angular/core';

interface CaseStudy {
    id: number;
    title: string;
    subtitle: string;
    description: string;
    icon: string;
}

@Component({
    selector: 'app-case-studies',
    templateUrl: './case-studies.component.html',
    styleUrls: ['./case-studies.component.scss']
})
export class CaseStudiesComponent implements OnInit {
    caseStudies: CaseStudy[] = [
        {
            id: 1,
            title: 'Delhi Private School',
            subtitle: 'IFP Installations',
            description: 'Improved student engagement & teacher efficiency.',
            icon: 'school'
        },
        {
            id: 2,
            title: 'State Govt ICT Project',
            subtitle: 'Digital Classrooms',
            description: 'Successful deployment with training & after-sales support.',
            icon: 'account_balance'
        },
        {
            id: 3,
            title: 'Education Institution',
            subtitle: 'LMS Transformation',
            description: 'Improvement in time management & communication',
            icon: 'trending_up'
        }
    ];

    ngOnInit(): void { }
}
